var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('anamnesis',_vm._b({attrs:{"dataCrud":_vm.localDataCrud,"dataCrud2":_vm.localDataCrud2},on:{"update:dataCrud":function($event){_vm.localDataCrud=$event},"update:data-crud":function($event){_vm.localDataCrud=$event},"update:dataCrud2":function($event){_vm.localDataCrud2=$event},"update:data-crud2":function($event){_vm.localDataCrud2=$event}}},'anamnesis',{
      ..._vm.schema,
      handleEventsCrud: _vm.handleEventsCrud,
      handleEvents: _vm.handleEvents,
      handleEvents2: _vm.handleEvents2,
      dialogTraceDiag: _vm.dialogTraceDiag,
      save: _vm.save,
      clickRowInfo: _vm.clickRowInfo,
      clickRowInfo2: _vm.clickRowInfo2,
      remove: _vm.remove,
      remove2: _vm.remove2,
      snackbar: _vm.snackbar,
      overlay: _vm.overlay,
      overlayMessage: _vm.overlayMessage,
      toggleOverlay: _vm.toggleOverlay,
      status: _vm.status,
    },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }